<template>
	<div class="incenters">
		<div style="">
			<Commonbtn backgroundColor="#FFF" title="编辑绑定" fontSize="14px" @btnclick="adduser"
				:src="require('@/assets/icon/icon-add.png')">
			</Commonbtn>
			<CommonbtnUpLoad style="display: inline-block;margin-top: 10px;" backgroundColor="#FFF" title="导入"
				fontSize="14px" @getFile="proImport" types="file" :src="require('@/assets/icon/icon-drjys.png')">
			</CommonbtnUpLoad>
			<Commonbtn backgroundColor="#FFF" title="导出" fontSize="14px" @btnclick="handExport"
				:src="require('@/assets/icon/daoc.png')">
			</Commonbtn>
			<a style="display: inline-block;font-size: 12px;margin-left: 10px;color: #00266D;text-decoration: underline;cursor: pointer;"
				@click="ProductlineDowload">导入模版下载</a>
		</div>
		<!-- style="border: 1px solid blue;" -->
		<div class="TableWidth">
			<Commontable @onRowClick="onRowClick" colnum=81 :tableData="tableData" :headerData="headerData"
				height="100%">
			</Commontable>
			<div class="pagination">
				<Pagination :pageSize="pageSize" @handleCurrentChange="handleCurrentChange"
					@handleSizeChange="handleSizeChange" :total="total"></Pagination>
			</div>
		</div>
		<DialogFrom width="1000px" :title="`当前绑定${proTitle}产品`" :dialogVisible="dialogVisibles" @cancel="cancel"
			:OKASCAN="false">
			<div class="from">
				<div class="input-tops"
					style="width: 100%;box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);height:150px;">
					<div v-for="(item , index) of formdata" :key="index" style="display: inline-block;">
						<Commondropdownlist ref="topfrom" :lablewith="item.lablewith" :inputdata="item.inputdata"
							:title="item.title" :fontSize="item.fontSize" :color="item.color"
							:placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype"
							:event="item.event" :options="item.options" :width="item.width" @invClass="getHelperLevel3"
							@level3Chage="getHelperLevel4">
						</Commondropdownlist>
					</div>
					<div class="Btngroups">
						<CommonBtngroup :qhide="false" @select="select" @reset="reset"></CommonBtngroup>
					</div>
				</div>
				<div class="TableFlex" style="margin-top: 24px;">
					<div class="flexBtn">
						<Commonbtn backgroundColor="#FFF" title="保存" fontSize="14px" style="margin-left:0px !important;"
							@btnclick="handSave" />
						<Commonbtn backgroundColor="#FFF" title="全部关联" fontSize="14px" @btnclick="handAllRelate" />
						<Commonbtn backgroundColor="#FFF" title="条件关联" fontSize="14px" @btnclick="handConRelate" />
						<Commonbtn backgroundColor="#FFF" title="全部取消" fontSize="14px" @btnclick="handAllCancel" />
						<Commonbtn backgroundColor="#FFF" title="条件取消" fontSize="14px" @btnclick="handConCancel" />
					</div>
					<Commontable ref="comtable" style="margin-left: 0%;" @onRowClick="onRowClick" colnum=7
						:tableData="tableDataPro" :headerData="headerDataPro" height="100%"
						@handleSelectionChange="handleSelectionChange">
					</Commontable>
					<div class="pagination">
						<Pagination :pageSize="pageSize" @handleCurrentChange="handleCurrentChangePro"
							@handleSizeChange="handleSizeChangePro" :total="Count"></Pagination>
					</div>
				</div>
			</div>
		</DialogFrom>
		<DialogFrom width="890px" :title="title" :dialogVisible="dialogVisiblesdrjg" @cancel="canceldrjg"
			@dialogOK="dialogOKdrjg">
			<div class="from">
				<Commontable @onRowClick="onRowClick" width="830px" colnum=100 :tableData="tableDatadrjg" height="100%">
				</Commontable>
			</div>
		</DialogFrom>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledel" @cancel="canceldel" @dialogOK="dialogOKdel"
			:src="require('@/assets/icon/icon-del2.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要删除这条档案吗？</span>
		</Dialog>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledeactivate" @cancel="canceldeactivate"
			@dialogOK="dialogOKdeactivate" :src="require('@/assets/icon/icon-del2.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要停用这条档案吗？</span>
		</Dialog>
	</div>
</template>
<script>
	import CommonBtngroup from '../../../../components/commongroup.vue'
	import Commondropdownlist from '../../../../components/common-dropdownlist.vue'
	import Commontable from '../../../../components/common-table.vue'
	import Commonbtn from '../../../../components/common-btn.vue'
	import Pagination from '../../../../components/pagination.vue'
	import DialogFrom from '../../../../components/dialog-from.vue'
	import fromdata from '../fromData/add'
	import Dialog from '../../../../components/dialog.vue'
	import Commondown from '../../../../components/common-down.vue'
	import CommonbtnUpLoad from '../../../../components/common-upload.vue'
	import {
		InventoryClassList,
	} from '@/api/home'

	import {
		DownloadInventoryProvince,
		ImportInventoryProvince,
		ListForEditInventoryProvince,
		EditInventoryProvince,
		AllRelateInventoryProvince,
		AllCancelInventoryProvince,
		ConditionRelateInventoryProvince,
		ConditionCancelInventoryProvince,
		GetHelperLevel3,
		GetHelperLevel4
	} from '@/api/newsapi'
	export default {
		components: {
			CommonBtngroup,
			Commontable,
			Commonbtn,
			Pagination,
			DialogFrom,
			Commondropdownlist,
			Dialog,
			Commondown,
			CommonbtnUpLoad
		},
		props: {
			proTitle: {
				type: String,
				default: ''
			},
			proCode: {
				type: String,
				default: ''
			},
			tableData: {
				type: Array,
				default: []
			},
			total: {
				type: Number,
				default: 0
			}
		},
		data: function() {
			return {
				LEVEL3: '',
				LEVEL4: '',
				selectCheckboxs: [],
				invAddCode: '',
				invName: '',
				invClass: '',
				pageIndex: 1,
				pageSize: 10,
				Count: 0,
				tableDataPro: [],
				headerDataPro: [{
						types: 'selection',
						label: '复选框',
					}, {
						prop: 'InvAddCode',
						label: '产品型号',
					},
					{
						prop: 'InvName',
						label: '产品名称',
					},
					{
						prop: 'InvClassName',
						label: '产品线',
						columnwidth: 90
					},
					{
						prop: 'MFName',
						label: '生产厂商',
						columnwidth: 130
					},
					{
						prop: 'LEVEL1',
						label: 'LEVEL1',
						columnwidth: 100
					},
					{
						prop: 'LEVEL2',
						label: 'LEVEL2',
						columnwidth: 100
					},
					{
						prop: 'LEVEL3',
						label: 'LEVEL3',
						columnwidth: 110
					},
					{
						prop: 'LEVEL4',
						label: 'LEVEL4',
						columnwidth: 80
					}
				],
				dialogVisibles: false,
				dialogVisibledel: false,
				dialogVisibledeactivate: false,
				dialogVisiblesU8: false,
				dialogVisiblesU8d: false,
				rightboo: false,
				dwonleft: false,
				rowboo: false,
				dialogVisiblesdrjg: false,
				title: '',
				invClass: '',
				invClassName: '',
				isBarCodeControl: '',
				parentClass: '',
				invClassupdate: '',
				invClassNameupdate: '',
				ptype: '',
				tableDatadrjg: [],
				formdata: [{
						inputdata: '',
						title: '产品型号',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '210px',
						lablewith: '70px'
					},
					{
						inputdata: '',
						title: '产品名称',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '210px'
					},
					{
						inputdata: '',
						title: '产品线',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'select',
						options: [],
						width: '210px',
						lablewith: '110px',
						event: "invClass",
					},
					{
						inputdata: '',
						title: 'L3',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'select',
						options: [],
						width: '220px',
						lablewith: '70px',
						event: "level3Chage",
					},
					{
						inputdata: '',
						title: 'L4',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'select',
						options: [],
						width: '220px',
						lablewith: '80px'
					},
				],
				headerData: [{
						prop: 'InvAddCode',
						label: '产品型号',
					},
					{
						prop: 'InvName',
						label: '产品名称',
					},
					{
						prop: 'InvClassName',
						label: '产品线',
						columnwidth: 90
					},
					{
						prop: 'MFName',
						label: '生产厂商',
						columnwidth: 130
					},
					{
						prop: 'LEVEL1',
						label: 'LEVEL1',
						columnwidth: 100
					},
					{
						prop: 'LEVEL2',
						label: 'LEVEL2',
						columnwidth: 100
					},
					{
						prop: 'LEVEL3',
						label: 'LEVEL3',
						columnwidth: 110
					},
					{
						prop: 'LEVEL4',
						label: 'LEVEL4',
						columnwidth: 80
					},
					{
						prop: 'CreatorName',
						label: '创建人',
						columnwidth: 110
					},
					{
						prop: 'CreateTime',
						label: '创建人时间',
						columnwidth: 150
					}
				],
				qus: [],
				qx: {
					add: false,
					update: false,
					del: false,
					stopif: true,
					daoc: true,
					assignment: false,
					enabled: false,
					submit: false,
					skip: false, //跳过
					reset: false, //重置
					setting: false
				},
			}
		},
		mounted() {
			this.fromdataadd = JSON.parse(JSON.stringify(fromdata))
			//this.QX()
		},
		methods: {
			QX() {
				let data = JSON.parse(localStorage.getItem("MenusData"))
				let MenuID = this.$route.query.MenuID
				// console.log(data.Menus[0].Nodes[1], "data")
				data.Menus[0].Nodes.map((item, index) => {
					if (item.NodeID == 34) {
						item.Nodes.map((items, indexs) => {
							if (items.NodeID == 39) {
								this.qus = items.Nodes
							}
						})
					}
					// console.log(this.qus, 'this.qus');
				})
				if (this.qus) {
					this.qus.map((item, index) => {
						if (item.NodeName == 'add') {
							this.qx.add = true
						} else if (item.NodeName == 'edit') {
							this.qx.update = true
						} else if (item.NodeName == 'delete') {
							this.qx.del = true
						} else if (item.NodeName == 'stopif') {
							this.qx.del = true
						} else if (item.NodeName == 'assignment') {
							this.qx.assignment = true
						} else if (item.NodeName == 'enabled') {
							this.qx.enabled = true
						} else if (item.NodeName == 'skip') {
							this.qx.skip = true
						} else if (item.NodeName == 'reset') {
							this.qx.reset = true
						} else if (item.NodeName == 'setting') {
							this.qx.setting = true
						}
					})
				}
			},
			// 获取产品线下拉
			async inventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({})
				if (code == 0) {
					this.formdata[2].options = []
					data.data.map((item, index) => {
						this.formdata[2].options.push({
							key: item.InvClass,
							value: item.InvClassName
						})
					})
				}
			},
			// 导入
			async inventoryImport(file) {
				if (file) {
					const loading = this.$loading({
						lock: true,
						text: '上传中...',
						spinner: 'el-icon-loading',
						background: 'rgba(255,255,255,0.3)'
					});
					let formData = new FormData()
					formData.append("file", file)
					let res = await ImportInventoryProvince(formData)
					if (res.code == 0) {
						this.$message({
							type: 'success',
							message: '导入成功'
						})
						this.$emit('reload');
					} else if (res.code == 2) {
						this.dialogVisiblesdrjg = true
						this.tableDatadrjg = res.data
						this.title = "导入结果"
					} else {
						this.$message({
							type: 'warning',
							message: res.message
						})
					}
					loading.close();
				}
			},
			//查询绑定数据
			async getInventoryProvinceListForEdit() {
				let {
					data,
					code,
					message
				} = await ListForEditInventoryProvince({
					invClass: this.invClass,
					invName: this.invName,
					invAddCode: this.invAddCode,
					provinceID: this.proCode,
					LEVEL3: this.LEVEL3,
					LEVEL4: this.LEVEL4,
					pageSize: this.pageSize,
					pageIndex: this.pageIndex
				})
				if (code == 0) {
					this.Count = data.Count
					if (data.data) {
						this.tableDataPro = data.data;
						this.$nextTick(() => {
							data.data.map(item => {
								this.$refs.comtable.toggleRowSelection(item, item.IsRelationProvince ?
									true : false);
							})
						})
					}
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			//获取l3数据
			async getHelperLevel3() {
				let {
					code,
					data
				} = await GetHelperLevel3({
					InvClass: this.$refs.topfrom[2].modelvalue
				});
				if (code == 0) {
					this.$refs.topfrom[3].modelvalue = '';
					this.$refs.topfrom[4].modelvalue = '';
					this.formdata[3].options = [];
					data.map((item, index) => {
						this.formdata[3].options.push({
							key: item.value,
							value: item.key,
						});
					});
				}
			},
			//获取l4数据
			async getHelperLevel4() {
				let {
					code,
					data
				} = await GetHelperLevel4({
					InvClass: this.$refs.topfrom[2].modelvalue,
					LEVEL3: this.$refs.topfrom[3].modelvalue
				});
				if (code == 0) {
					this.$refs.topfrom[4].modelvalue = '';
					this.formdata[4].options = [];
					data.map((item, index) => {
						this.formdata[4].options.push({
							key: item.value,
							value: item.key,
						});
					});
				}
			},
			//导出数据
			handExport() {
				this.$emit('export');
			},
			// 导出模板
			async inventoryDownloadTemplet() {
				let {
					data,
					code,
					message
				} = await DownloadInventoryProvince({})
				if (code == 0) {
					window.location.href = data
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			proImport(file) {
				this.inventoryImport(file)
			},
			ProductlineDowload() {
				this.inventoryDownloadTemplet()
			},
			onRowClick(val) {
				this.rowboo = true
				//console.log(val, "val")
				this.invClassupdate = val.InvClass
				this.invClassNameupdate = val.InvClassName
			},
			commclick(type) {
				this[type] = true
			},
			handleCurrentChange(pageindex) {
				this.$emit('handleCurrentChange', pageindex)
			},
			handleSizeChange(paegSzie) {
				this.$emit('handleSizeChange', paegSzie)
			},
			adduser() {
				this.dialogVisibles = true
				this.inventoryClassList();
				this.getInventoryProvinceListForEdit();
				// this.getHelperLevel3();
				// this.getHelperLevel4()
			},
			cancel() {
				this.dialogVisibles = false
				this.$emit('reload');
			},
			canceledit() {
				this.dialogVisiblesedit = false
			},
			canceldel() {
				this.dialogVisibledel = false
			},
			dialogOKdel() {
				this.inventoryClassDelete()
				this.dialogVisibledel = false
			},
			deactivate() {
				this.dialogVisibledeactivate = true
			},
			canceldeactivate() {
				this.dialogVisibledeactivate = false
			},
			dialogOKdeactivate() {
				this.dialogVisibledeactivate = false
			},
			downs(index) {
				//console.log("index", index)
				if (index == 0) {
					this.dialogVisiblesU8 = true
				}
				if (index == 1) {
					this.dialogVisiblesU8d = true
				}
			},
			cancelU8() {
				this.dialogVisiblesU8 = false
			},
			cancelU8d() {
				this.dialogVisiblesU8d = false
			},
			canceldrjg() {
				this.dialogVisiblesdrjg = false
			},
			dialogOKdrjg() {
				this.dialogVisiblesdrjg = false
			},
			select() {
				this.pageIndex = 1
				this.invAddCode = this.$refs.topfrom[0].modelvalue
				this.invName = this.$refs.topfrom[1].modelvalue
				this.invClass = this.$refs.topfrom[2].modelvalue
				this.LEVEL3 = this.$refs.topfrom[3].modelvalue
				this.LEVEL4 = this.$refs.topfrom[4].modelvalue
				this.getInventoryProvinceListForEdit();
			},
			//
			reset() {
				this.$refs.topfrom.map((item, index) => {
					item.modelvalue = ''
				})
			},
			async handSave() {
				let arrs = [];
				let ids = this.selectCheckboxs.map(it => it.InvCode);
				this.tableDataPro && this.tableDataPro.map(it => {
					arrs.push({
						ProvinceID: this.proCode,
						InvCode: it.InvCode,
						IsRelation: ids.includes(it.InvCode) ? 1 : 0
					})
				})
				const loading = this.$loading({
					lock: true,
					text: '正在加载...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					code,
					message
				} = await EditInventoryProvince(arrs)
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '保存成功'
					});
					this.getInventoryProvinceListForEdit();
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
				loading.close()
			},
			//全部关联
			async handAllRelate() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					code,
					message
				} = await AllRelateInventoryProvince({
					ProvinceID: this.proCode,
					invClass: this.invClass,
					invName: this.invName,
					invAddCode: this.invAddCode,
					LEVEL3: this.LEVEL3,
					LEVEL4: this.LEVEL4
				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '全部关联成功'
					});
					this.getInventoryProvinceListForEdit();
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
				loading.close()
			},
			//条件关联
			async handConRelate() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					code,
					message
				} = await ConditionRelateInventoryProvince({
					ProvinceID: this.proCode,
					invClass: this.invClass,
					invName: this.invName,
					invAddCode: this.invAddCode,
					LEVEL3: this.LEVEL3,
					LEVEL4: this.LEVEL4
				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '条件关联成功'
					});
					this.getInventoryProvinceListForEdit();
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
				loading.close()
			},
			//全部取消
			async handAllCancel() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					code,
					message
				} = await AllCancelInventoryProvince({
					ProvinceID: this.proCode,
					invClass: this.invClass,
					invName: this.invName,
					invAddCode: this.invAddCode,
					LEVEL3: this.LEVEL3,
					LEVEL4: this.LEVEL4
				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '全部取消成功'
					});
					this.getInventoryProvinceListForEdit();
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
				loading.close()
			},
			//条件取消
			async handConCancel() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					code,
					message
				} = await ConditionCancelInventoryProvince({
					ProvinceID: this.proCode,
					invClass: this.invClass,
					invName: this.invName,
					invAddCode: this.invAddCode,
					LEVEL3: this.LEVEL3,
					LEVEL4: this.LEVEL4
				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '条件取消成功'
					});
					this.getInventoryProvinceListForEdit();
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
				loading.close()
			},
			//复选框选中
			handleSelectionChange(e) {
				this.selectCheckboxs = e;
			},
			handleCurrentChangePro(pageindex) {
				this.pageIndex = pageindex
				this.getInventoryProvinceListForEdit();
			},
			handleSizeChangePro(paegSzie) {
				this.pageSize = paegSzie
				this.getInventoryProvinceListForEdit();
			}
		}
	}
</script>

<style lang="less" scoped>
	.incenters {
		height: 100%;

		.pagination {
			display: flex;
			justify-content: center;
			align-items: center;
			margin-top: 16px;
			padding-bottom: 16px;
		}

		// div {
		//   margin-left: 8px;
		//   margin-right: 8px;
		//   margin-top: 5px;
		//   margin-bottom: 5px;

		// }
		.from {
			width: 100%;

			.input-tops {
				width: 980px;
				height: 0px;
				box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
				background-color: #ffffff;
				padding-top: 9px;
				padding-bottom: 64px;
				overflow: hidden;
				position: relative;
				transition: all 0.3s;
			}

			.Btngroup {
				display: inline-block;
				float: right;
				margin-right: 10px;
				width: 350px;
				height: 50px;
				background-color: #ffffff;
				position: relative;
				bottom: 45px;
			}

		}

		.signingroles {
			height: 500px;
			width: 100%;
			// display: flex;
			// justify-content: space-between;
			// align-items: center;
			// border: 1px solid red;

			.left {
				height: 240px;
				width: 470px;
				border: 1px solid #e6e6e6;
			}

			.right {
				height: 240px;
				width: 470px;
				border: 1px solid #e6e6e6;
				// pointer-events: none;
			}
		}
	}

	.right-s {
		position: absolute;
		z-index: 99;
		opacity: 0.5;
		right: 21px;
		width: 470px;
		height: 240px;
		background-color: #ffffff;
		cursor: no-drop;
	}

	.dwonleft {
		width: 170px;
		height: 48px;
		position: absolute;
		background-color: #ffffff;
		z-index: 99;
		right: 350px;
		top: 322px;
		text-align: center;
		line-height: 48px;
		color: #333333;
		box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
			0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
		border-radius: 2px;
		font-size: 14px;
		cursor: pointer;
	}

	.dwonleft:hover {
		background-color: #f0f0f0;
	}
</style>